import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import ErrorPopup from '../components/ErrorPopup';
import FeedbackWidget, {
  FEEDBACK_WIDGET_PAGE_BOTTOM_PADDING,
} from '../components/FeedbackWidget';

const THEME_STORAGE_KEY = 'buildmate_theme';

function getInitialDarkMode(): boolean {
  try {
    return localStorage.getItem(THEME_STORAGE_KEY) === 'dark';
  } catch {
    return false;
  }
}

export default function PanelLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [darkMode, setDarkMode] = useState(getInitialDarkMode);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode);
    try {
      localStorage.setItem(THEME_STORAGE_KEY, darkMode ? 'dark' : 'light');
    } catch {
      // Ignore quota / private-mode failures
    }
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode((prev) => !prev);
  };

  return (
    <>
      <div
        className={`min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors ${
          darkMode ? 'dark' : ''
        }`}
      >
        <Header
          onMenuClick={() => setSidebarOpen(!sidebarOpen)}
          onThemeToggle={toggleDarkMode}
          darkMode={darkMode}
        />
        <div className="flex flex-col min-h-screen">
          <div className="flex flex-1">
            <Sidebar isOpen={sidebarOpen} />
            <main
              className={`flex-1 min-w-0 transition-all duration-300 ${FEEDBACK_WIDGET_PAGE_BOTTOM_PADDING} ${
                sidebarOpen ? 'ml-64' : 'ml-0'
              }`}
            >
              <Outlet />
            </main>
          </div>
        </div>
      </div>
      <ErrorPopup />
      <FeedbackWidget />
    </>
  );
}
